import { Button } from '@/src/components/Commons/Button';
import { TOKEN_GOV_TN_STR } from '@/src/utils/constants';
import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import GetTokenGovTx from './GetTokenGovTx/GetTokenGovTx';
import styles from './ModalGetTokenGov.module.scss';
import { useModalGetTokenGov } from './useModalGetTokenGov';

export const ModalGetTokenGov = () => {
    //--------------------------------------
    const { isRefreshing, isOpen, handleOpen, handleClose, txComponentProps } = useModalGetTokenGov();
    //--------------------------------------
    return (
        <>
            <Button mode="outline-no-arrow" size="small" width={100} onClick={handleOpen}>
                Get {TOKEN_GOV_TN_STR}
            </Button>
            {isOpen === true ? (
                <div className={styles.modal}>
                    <div className={`${styles.main}`}>
                        <div className={styles.popUp}>
                            <>
                                <header className={styles.headerModal}>
                                    <h2 className={styles.titleModal}>Get {TOKEN_GOV_TN_STR}</h2>
                                    <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                        <use href={CLOSE}></use>
                                    </svg>
                                </header>
                                <GetTokenGovTx {...txComponentProps} />
                            </>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
    //--------------------------------------
};
